import { Directive, AfterViewInit, ElementRef, Host, Optional, HostListener, Input, HostBinding } from '@angular/core';
import { PanchangCalendarComponent } from './panchang-calendar.component';
import * as _ from 'underscore';
import moment from 'moment';
import { PunchangDayJson } from './panchang-day-json';
import { DateService } from 'app/services/date.service';

@Directive({
    selector: '[appPunchangCalendar]',
    standalone: false
})
export class PunchangCalendarDirective implements AfterViewInit {
  @Input() @HostBinding('tabindex') tabindex = -1;

  constructor(private el: ElementRef, @Optional() @Host() private panchangCalender: PanchangCalendarComponent) {
    this.el.nativeElement.focus();

  }

  ngAfterViewInit() {
    this.el.nativeElement.focus();
  }
  @HostListener('keydown', ['$event'])
  keyDownListener(event: KeyboardEvent) {
    switch (event.keyCode) {
      case 33: {

        event.preventDefault();
        this.pgUpNavigation()  // pageup
        break;
      }
      case 34: {
        event.preventDefault();
        this.pgDownNavigation(); // pagedown
        break;
      }
      case 13: {
        this.navigate(event.keyCode);;
        break;

      }
      case 38:
        {
          event.preventDefault();
          this.navigate(event.keyCode);; break;
        } // up arrow
      case 40: {
        event.preventDefault();
        this.navigate(event.keyCode);; break;
      }// dwn arrow
      case 37: {
        event.preventDefault();
        this.navigate(event.keyCode);
        break;
      } // left arrow
      case 39: {
        event.preventDefault();
        this.navigate(event.keyCode);;
        break;
      }// right arrow
      default:
        if (event.keyCode > 64 && event.keyCode <= 95 || event.keyCode > 105 && event.keyCode <= 223
          || event.keyCode > 15 && event.keyCode <= 36 || event.keyCode === 8 || event.keyCode > 44 && event.keyCode <= 46) {
          event.preventDefault();
        } else {
          event.preventDefault();
        }
    }

  }
  get weeks() {
    const fullWeek = _.reduce(_.map(this.panchangCalender.weeks, e => e.week), (a, b) => a.concat(b));
    const weeks: PunchangDayJson[] = _.filter(fullWeek, e => !!e.date);

    return weeks;
  }
  navigate(key: number) {

    const selectedDay: PunchangDayJson = _.find(this.weeks, (e: PunchangDayJson) => e.isSelected);

    const currentDay = new Date(selectedDay.year, selectedDay.month, selectedDay.date);
    let dayinPan = selectedDay;
    switch (key) {
      case 37: {
        dayinPan = this.leftNavigation(currentDay, this.weeks);
        break;
      }
      case 39: {
        dayinPan = this.rightNavigation(currentDay, this.weeks);
        break;
      }
      case 38: {
        dayinPan = this.upNavigation(currentDay, this.weeks);
        break;
      }// 
      case 40: {
        dayinPan = this.downNavigation(currentDay, this.weeks);
        break;
      }// 

    }
    if (key === 13) {
      this.panchangCalender.choosedate(dayinPan, this.panchangCalender.weeks);
    } else {
      this.panchangCalender.choosedate(dayinPan, this.panchangCalender.weeks, true);
      selectedDay.isSelected = false;
    }


  }
  rightNavigation(currentDay: Date, weeks: PunchangDayJson[], isLastDay = false) {
    const nextDayinEN = isLastDay ? currentDay : moment(currentDay).add(1, 'd').toDate();
    const index = _.findIndex(weeks, (day: PunchangDayJson) => this.isDateSame(nextDayinEN, day));
    const nextDay = weeks[index];
    if (this.isLastDayOfMonth(currentDay)) {

      this.panchangCalender.currentDate = nextDayinEN;
      this.panchangCalender.calculateWeeks();
      return this.rightNavigation(nextDayinEN, this.weeks, true);
    }
    return nextDay;
  }
  leftNavigation(currentDay: Date, weeks: PunchangDayJson[], isFirstDay = false) {
    const previousDayInEn = isFirstDay ? currentDay : moment(currentDay).subtract(1, 'd').toDate();
    const index = _.findIndex(weeks, (day: PunchangDayJson) => this.isDateSame(previousDayInEn, day));

    const previousDay = weeks[index];
    if (currentDay.getDate() === 1) {
      this.panchangCalender.currentDate = previousDayInEn;
      this.panchangCalender.calculateWeeks();
      return this.leftNavigation(previousDayInEn, this.weeks, true);
    }
    return previousDay;
  }
  upNavigation(currentDay: Date, weeks: PunchangDayJson[], isPreviousWeek = false) {
    const dayInPreviousWeek = isPreviousWeek ? currentDay : moment(currentDay).subtract(7, 'd').toDate();

    const index = _.findIndex(weeks, (day: PunchangDayJson) => this.isDateSame(dayInPreviousWeek, day));
    const sevenDayBefore = weeks[index];
    if (!sevenDayBefore) {
      this.panchangCalender.currentDate = dayInPreviousWeek;
      this.panchangCalender.calculateWeeks();
      return this.upNavigation(dayInPreviousWeek, this.weeks, true);
    }

    return sevenDayBefore;
  }
  downNavigation(currentDay: Date, weeks: PunchangDayJson[], isPreviousWeek = false) {
    const dayInNextWeek = isPreviousWeek ? currentDay : moment(currentDay).add(7, 'd').toDate();

    const index = _.findIndex(weeks, (day: PunchangDayJson) => this.isDateSame(dayInNextWeek, day));
    const sevenDayAfter = weeks[index];
    if (!sevenDayAfter) {
      this.panchangCalender.currentDate = dayInNextWeek;
      this.panchangCalender.calculateWeeks();
      return this.upNavigation(dayInNextWeek, this.weeks, true);
    }
    return sevenDayAfter;
  }
  pgUpNavigation() {
    const currentYear = +this.panchangCalender.currentEnYear;
    const selectedDay: PunchangDayJson = _.find(this.weeks, (e: PunchangDayJson) => e.isSelected);
    const currentDay = new Date(selectedDay.year, selectedDay.month, selectedDay.date);
    this.panchangCalender.currentDate = moment(currentDay).subtract(1, 'year').toDate();
    this.panchangCalender.calculateWeeks();
    const index = _.findIndex(this.weeks, (day: PunchangDayJson) => this.isDateSame(this.panchangCalender.currentDate, day));
    const nextDay = this.weeks[index];
    this.panchangCalender.choosedate(nextDay, this.panchangCalender.weeks, true);

  }
  pgDownNavigation() {
    const selectedDay: PunchangDayJson = _.find(this.weeks, (e: PunchangDayJson) => e.isSelected);
    const currentDay = new Date(selectedDay.year, selectedDay.month, selectedDay.date);
    this.panchangCalender.currentDate = moment(currentDay).add(1, 'year').toDate();
    this.panchangCalender.calculateWeeks();
    const index = _.findIndex(this.weeks, (day: PunchangDayJson) => this.isDateSame(this.panchangCalender.currentDate, day));
    const nextDay = this.weeks[index];
    this.panchangCalender.choosedate(nextDay, this.panchangCalender.weeks, true);
  }
  isDateSame(date1: Date, day: PunchangDayJson): boolean {
    return DateService.isSame(date1, new Date(day.year, day.month, day.date));
  }


  isLastDayOfMonth(date: Date) {
    return date.getDate() === new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

}
